const isDevelopment = process.env.REACT_APP_IS_DEVELOPMENT === 'true'
const isDevelopmentStorageOverride = sessionStorage.isDevelopment
export default isDevelopmentStorageOverride === undefined
  ? isDevelopment
  : isDevelopmentStorageOverride === 'true'
